import { render, staticRenderFns } from "./CreateInstance.vue?vue&type=template&id=bddaf49e"
import script from "./CreateInstance.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateInstance.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports